/* IMPORTS ------------------------------------------------------------------------------------- */
// PLUGINS
import { v4 as uuid } from 'uuid';
import { writable } from 'svelte/store';
/* CONFIG -------------------------------------------------------------------------------------- */
const DURATION = 20 * 1000;
/* INTERFACES --------------------------------------------------------------------------------- */
let lastMessage = undefined;
// Create a writable store for messages
export const MESSAGES = writable([]);
// Function to remove a message from the store
export const removeMessage = (key) => {
    MESSAGES.update(messages => messages.filter(message => message.key !== key));
};
// Function to add a message to the store
export const addMessage = (message) => {
    const MESSAGE = { ...message, createdOn: Date.now(), key: uuid() };
    if (lastMessage !== undefined
        && MESSAGE.heading === lastMessage.heading
        && MESSAGE.description === lastMessage.description
        && MESSAGE.type === lastMessage.type
        && MESSAGE.createdOn - lastMessage.createdOn <= 500) {
        return;
    }
    MESSAGES.update(messages => [...messages, MESSAGE]);
    lastMessage = MESSAGE;
    setTimeout(() => {
        removeMessage(MESSAGE.key);
    }, DURATION);
};
